import React from 'react';

import { PanelItem } from '../PanelItem/PanelItem';

import styles from './PanelItemsOverview.module.scss';
import accessImage from '@components/Pages/Features/access.png';
import analyticsImage from '@components/Pages/Features/analytics.png';
import managementImage from '@components/Pages/Features/management.png';
import reportsImage from '@components/Pages/Features/reports.png';

const items = [
  {
    title: 'Real-time analytics & daily reports',
    description:
      'Get valuable insights into website traffic patterns, monitor traffic spikes, identify bottlenecks, and respond quickly to any issues that might arise.',
    image: {
      src: reportsImage,
      width: 730,
      height: 380,
      alt: '',
    },
  },
  {
    title: 'Role-based access',
    description: 'Reduce the risk of accidental or malicious changes to the CDN setup.',
    image: {
      src: accessImage,
      width: 730,
      height: 380,
      alt: '',
    },
  },
  {
    title: 'Custom analytics',
    description: 'Fully customised built-in analytics available with enterprise level plans.',
    image: {
      src: analyticsImage,
      width: 730,
      height: 380,
      alt: '',
    },
  },
  {
    title: 'Straightforward CDN management',
    description:
      'Effectively manage your CDN, improve performance, and streamline common tasks, such as content caching and purging.',
    image: {
      src: managementImage,
      width: 730,
      height: 380,
      alt: '',
    },
  },
];

export const PanelItemsOverview: React.FC = () => (
  <div className={styles.contentWrapper}>
    {items.map(({ title, description, image }) => (
      <PanelItem
        key={title}
        className={styles.item}
        description={description}
        image={image}
        title={title}
      />
    ))}
  </div>
);
